import { FC } from 'react';

import { Title, TitleProps } from '@mantine/core';

export const TitleWithLeftLine: FC<
  TitleProps & {
    size?: 'sm' | 'md';
  }
> = ({ size = 'md', ...props }) => (
  <Title
    color="#78716C"
    order={3}
    fz={14}
    fw={600}
    p={size === 'md' ? '4px' : '2px'}
    lh={size === 'md' ? 1 : 0.7}
    sx={{
      height: size === 'md' ? '24px' : '14px',
      paddingLeft: '5px',
      borderLeft: '3px solid #78716C',
    }}
    {...props}
  >
    {props.children}
  </Title>
);
